import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumbs } from "../../components/core/Breadcrumbs";
import { UpsertAdjustmentForm } from "../../features/adjustment/components/UpsertAdjustmentForm";
import { AuthenticatedLayout } from "../../features/user/layouts/AuthendicatedLayout";

export const EditAdjustment = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, [id, navigate]);

  return (
    <AuthenticatedLayout>
      <Breadcrumbs />
      <UpsertAdjustmentForm id={id} />
    </AuthenticatedLayout>
  );
};
